import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useState } from 'react';
import { router } from './router';
import { Toaster } from './components/ui/toaster';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from '@/features/auth/components/AuthProvider';
import { queryClient } from '@/lib/query-config';
import './App.css';

function DevtoolsGate() {
  const [isDesktopWidth, setIsDesktopWidth] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.matchMedia('(min-width: 768px)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const query = window.matchMedia('(min-width: 768px)');
    const handleChange = (event: MediaQueryListEvent) => {
      setIsDesktopWidth(event.matches);
    };

    query.addEventListener('change', handleChange);

    return () => {
      query.removeEventListener('change', handleChange);
    };
  }, []);

  if (!import.meta.env.DEV || !isDesktopWidth) return null;

  return <ReactQueryDevtools initialIsOpen={false} />;
}

function App() {
  console.log('App component rendering');

  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light" storageKey="unitree-theme">
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
          <Toaster />
          <DevtoolsGate />
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
